import React, { useContext, useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styles from './ProgrammeSelector.module.css';
import catStyles from 'styles/modules/Categories.module.css';
import useAccessibility from 'hooks/useAccessibility';
import Button from "./Button";
import { ReactComponent as SpectaclesIcon } from 'icons/spectacle.svg';
import { ReactComponent as ConcertIcon } from 'icons/concert.svg';


const ProgrammeSelector = ({ activeTab }) => {
  const accessibilityVariant = useAccessibility();

  return (
    <nav className={styles.selectorSpectacle} aria-label="Sélection programme">
      <ul className={`${styles[activeTab + "Style"]}`}>
        <li>
          <a href="/programme" className={activeTab === 'all' ? styles.active : ''}>
            Tout le programme
          </a>
        </li>
        <li>
          <a href="/programme/spectacle" className={activeTab === 'spectacles' ? styles.active : ''}>
            <SpectaclesIcon className={styles.icon} /> Les Spectacles
          </a>
        </li>
        <li>
          <a href="/programme/concert" className={activeTab === 'concerts' ? styles.active : ''}>
            <ConcertIcon className={styles.icon} /> Les Concerts
          </a>
        </li>
      </ul>
    </nav>
  );
};

ProgrammeSelector.propTypes = {
  link: PropTypes.string.isRequired,               // Lien
  colorVariant: PropTypes.string,                  // Variante de couleur
  accessibilityVariant: PropTypes.string           // Variante pour l'accessibilité
};


export default ProgrammeSelector;
